import { render } from "./Fabricantes.vue?vue&type=template&id=098e3044&scoped=true"
import script from "./Fabricantes.vue?vue&type=script&lang=ts"
export * from "./Fabricantes.vue?vue&type=script&lang=ts"

import "./Fabricantes.vue?vue&type=style&index=0&id=098e3044&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-098e3044"

export default script